<script>
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'

export default {
  name: 'GridLoader',
  components: {
    ChevronDownIcon
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    aspectRatio: {
      type: Number,
      default: 1 / 1
    },
    columns: {
      type: Number,
      default: 2
    },
    gutter: {
      type: String,
      default: '10px'
    },
    margin: {
      type: String,
      default: '50px'
    }
  },
  data: () => ({
    scrollEnd: true,
    scrollStart: true
  }),
  computed: {
    styles () {
      return {
        container: {
          '--gutter': this.gutter,
          '--aspect-ratio': this.aspectRatio,
          '--margin': this.margin,
          '--columns': this.columns,
          '--scrollbar-width': `${window.innerWidth -
            document.documentElement.clientWidth}px`
        }
      }
    }
  },
  methods: {}
}
</script>

<template>
  <div
    class="container"
    :style="styles.container"
  >
    <div
      ref="scrollRef"
      class="grid"
    >
      <slot />
    </div>
    <div
      v-if="hasMore"
      key="hasMore"
    >
      <transition
        name="fade"
        mode="out-in"
      >
        <button
          v-if="!loading"
          key="loaded"
          class="btn-ver-mais"
          @click="() => $emit('verMaisClick')"
        >
          {{ wl.strings['btn-ver-mais'] }}
          <ChevronDownIcon />
        </button>
        <div
          v-else
          key="loading"
          class="spinner"
        />
      </transition>
    </div>
    <div
      v-else
      key="hasNoMore"
      class="btn-placeholder"
    />
  </div>
</template>

<style lang="scss" scoped>
.container {
  margin: 0 var(--margin);
  --container-width: calc(100vw - var(--scrollbar-width));
  --item-width: calc((var(--container-width) - ((2 * var(--margin)) + ((var(--columns) + 1) * var(--gutter)))) / var(--columns));
  --item-height: calc(var(--item-width) * var(--aspect-ratio));
  position: relative;
  .grid {
    justify-content: center;
    display: grid;
    grid-gap: var(--gutter);
    grid-template-columns: repeat(var(--columns), var(--item-width));
    > * {
      height: var(--item-height);
    }
    .margin {
      width: 100%;
      height: 100%;
    }
  }
  .btn-placeholder {
    height: 39px;
    margin: var(--gutter) auto;
  }
  .btn-ver-mais {
    background-color: transparent;
    border: none;
    color: var(--on-background);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    margin: var(--gutter) auto;
    height: 39px;
    cursor: pointer;
    &:focus {
      outline: none;
    }
    span {
      margin-top: -5px;
    }
  }
  .spinner{
    opacity: var(--opacity);
    transition: opacity 500ms linear;
    width: 39px;
    height: 39px;
    box-sizing: border-box;
    border-top: 3px solid var(--on-background);
    border-right: 3px solid transparent;
    border-radius: 50%;
    animation: rotation .7s linear infinite;
    margin: var(--gutter) auto;
  }
}

.app-bar-footer-layout {
  > .content {
    min-height: var(--min-height);
  }
}
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
  will-change: opacity;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

@keyframes rotation{
  from{
    transform: rotate(0deg);
  }
  to{
    transform: rotate(360deg);
  }
}
</style>
